import * as API from './api'
import * as Types from './Types'
import * as Constants from '../helpers/Constants'
import * as Strings from './strings'

export function tryGetPosts(token) {
  return dispatch => {
    dispatch({ 
      type: Types.GET_POSTS 
    })

    API.getPosts(token)
      .then(response => {
        dispatch({
          type: Types.GET_POSTS_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_POSTS_FAILED
        })
      })
  }
}

export function setCurrentPost(post) {
  return {
    type: Types.SET_POST,
    payload: post
  }
}

export function tryDeletePost(token, communityId, postId, language, alert) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_POST,
      loading: postId
    })

    API.deletePost(token, communityId, postId)
      .then(() => {
        dispatch({
          type: Types.DELETE_POST_SUCCESSFUL,
          payload: postId,
          loading: postId
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.DELETE_POST_FAILED,
          loading: postId
        })
      })
  }
}

export function tryDeleteComment(
  token,
  postId,
  commentId,
  language,
  alert,
  offline
) {
  if (offline) {
    return dispatch => {
      dispatch({
        type: Types.DELETE_COMMENT_SUCCESSFUL,
        payload: { postId, commentId },
        loading: commentId
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.DELETE_COMMENT,
      loading: commentId
    })

    API.deleteComment(token, postId, commentId)
      .then(() => {
        dispatch({
          type: Types.DELETE_COMMENT_SUCCESSFUL,
          payload: { postId, commentId },
          loading: commentId
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.DELETE_COMMENT_FAILED,
          loading: commentId
        })
      })
  }
}

export function removeMessage(alert, language) {
  return {
    type: Types.REMOVE_TOAST_MESSAGE
  }
}

export function tryLike(token, postId, language, alert, offline) {
  if (offline) {
    return dispatch =>
      dispatch({
        type: Types.LIKE_POST_SUCCESSFUL,
        payload: { id: generateId(), apartmentId: 1, postId },
        loading: postId
      })
  }

  return dispatch => {
    dispatch({
      type: Types.LIKE_POST,
      loading: postId
    })

    API.createLike(token, postId)
      .then(response => {
        dispatch({
          type: Types.LIKE_POST_SUCCESSFUL,
          payload: response.data.data,
          loading: postId
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.LIKE_POST_FAILED,
          loading: postId
        })
      })
  }
}

export function tryDeleteLike(token, postId, apartmentId, language, alert, offline) {
  if (offline) {
    return dispatch =>
      dispatch({
        type: Types.DISLIKE_POST_SUCCESSFUL,
        payload: { apartmentId: 1, postId },
        loading: postId
      })
  }

  return dispatch => {
    dispatch({
      type: Types.DISLIKE_POST,
      loading: postId
    })

    API.deleteLike(token, postId)
      .then(() => {
        dispatch({
          type: Types.DISLIKE_POST_SUCCESSFUL,
          payload: { apartmentId, postId },
          loading: postId
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.DISLIKE_POST_FAILED,
          loading: postId
        })
      })
  }
}

export function tryCreateComment(
  token,
  postId,
  data,
  language,
  alert,
  offline
) {
  if (offline) {
    return dispatch => {
      dispatch({
        type: Types.COMMENT_POST_SUCCESSFUL,
        payload: {
          ...data,
          id: generateId(),
          createdAt: '2018-10-14T18:43:54.522Z',
          postId,
          apartment: { id: 1, id: "100" }
        }
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.COMMENT_POST
    })

    API.createComment(token, postId, data)
      .then(response => {
        dispatch({
          type: Types.COMMENT_POST_SUCCESSFUL,
          payload: response.data.data
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.COMMENT_POST_FAILED
        })
      })
  }
}

function generateId() {
  return Math.floor(Math.random() * 1000000 + 1) // This may generate a duplicate key but I deem the odds of that to be fairly low.
}



// WEBPACK FOOTER //
// ./src/actions/Feed.js